<div class="page-container">
  <div class="form-container" *ngIf="formGroup">
    <frg-form-input
      id="title"
      type="text"
      label="Titre"
      [required]="true"
      [formGroup]="formGroup"
      [control]="formGroup.get('title')"
    ></frg-form-input>

    <frg-form-input
      id="referent"
      type="ngSelect"
      [selectValue]="profilResources"
      label="Référent"
      [required]="true"
      [formGroup]="formGroup"
      [control]="formGroup.get('referent')"
    ></frg-form-input>

    <div class="wrapper-resources">
      <div class="table-container">
        <div class="table-label">Liste du personnel soignant impliqué</div>
        <frg-table
          [keysBody]="caregiversTable"
          [keysColumn]="caregiversTableColumn"
          tableButton1="assets/icons/trash.svg"
          (onClick1)="removeCaregiver($event)"
        ></frg-table>
        <div class="buttons-container">
          <frg-button (activated)="addCaregiver()">Ajouter</frg-button>
        </div>
      </div>

      <div class="table-container">
        <div class="table-label">Liste des patients concernés</div>
        <frg-table
          [keysBody]="patientsTable"
          [keysColumn]="patientsTableColumn"
          [isRowsClickable]="true"
          (onClickRow)="addRemovePatient($event)"
          tableButton1="assets/icons/trash.svg"
          (onClick1)="removePatient($event)"
          [isEdit]="isEdit"
          (formSubmit)="updatePatientDates($event)"
          (formCancel)="isEdit = !isEdit"
        ></frg-table>
        <div class="buttons-container" *ngIf="!isEdit && patientsTable && patientsTable.objects && patientsTable.objects.length > 0">
          <frg-button (activated)="isEdit = !isEdit">Editer</frg-button>
        </div>
        <div class="icons-container">
          <div class="icon-wrapper" [title]="searchPatientButton.title" (click)="searchPatient()">
            <frg-inline-svg
              [fill]="searchPatientButton.icon.fill"
              [stroke]="searchPatientButton.icon.stroke"
              [src]="searchPatientButton.icon.src"
            ></frg-inline-svg>
          </div>
          <div class="icon-wrapper" [title]="listByAntecedentsButton.title" (click)="openListByAntecedents()">
            <frg-inline-svg
              [fill]="listByAntecedentsButton.icon.fill"
              [stroke]="listByAntecedentsButton.icon.stroke"
              [src]="listByAntecedentsButton.icon.src"
            ></frg-inline-svg>
          </div>
          <div class="icon-wrapper"
            [title]="addToPatientConsultationsButton.title"
            (click)="addProtocolToPatientsConsultations()"
            [ngClass]="{ 'disabled': selectedPatients.length <= 0 || !initialProtocol }">
            <frg-inline-svg
              [fill]="addToPatientConsultationsButton.icon.fill"
              [stroke]="addToPatientConsultationsButton.icon.stroke"
              [src]="addToPatientConsultationsButton.icon.src"
            ></frg-inline-svg>
          </div>
        </div>
      </div>
    </div>

    <div class="table-container margin">
      <div class="table-label">Liste des documents du protocole</div>
      <frg-table
        [keysBody]="documentsTable"
        [keysColumn]="documentsTableColumn"
        tableButton1="assets/icons/trash.svg"
        (onClick1)="removeDocument($event)"
      ></frg-table>
      <div class="buttons-container">
        <frg-button (activated)="addDocument()">Ajouter</frg-button>
      </div>
    </div>

    <div class="button-container margin" *ngIf="protocolId">
      <frg-button (activated)="addFollowUpAppointment()">Ajouter un rdv de suivi</frg-button>
    </div>

    <div class="rich-text-container">
      <div class="froala-wrapper" [formGroup]="formGroup">
          <froala-editor class="froala-editor" [froalaEditor]="editorOptions" [(froalaModel)]="editorContent" id="froalaDrop" #froalaDrop (froalaInit)="initialize($event)"
            formControlName="protocol" placeholder="Ajouter du texte ici..." ></froala-editor>
      </div>
      <div class="buttons-container">
        <frg-button (activated)="printProtocol()">Imprimer</frg-button>
      </div>
    </div>

    <div *ngIf="formGroup && formGroup.get('createdAt')" class="protocol-date-info">{{ formGroup.get('createdAt').value }}</div>
    <div *ngIf="formGroup && formGroup.get('updatedAt')" class="protocol-date-info">{{ formGroup.get('updatedAt').value }}</div>

    <div class="buttons-container">
      <frg-button *ngIf="protocolId" (activated)="deleteProtocol()" [backgroundColor]="'var(--danger)'">Supprimer</frg-button>

      <frg-button (activated)="cancelChanges()" [backgroundColor]="'var(--darkest-primary)'" [disabled]="!hasFormChange">Annuler</frg-button>

      <frg-button (activated)="validProtocol()" [disabled]="!canValidProtocol()">Valider</frg-button>

      <frg-button (activated)="saveProtocol()">Enregistrer</frg-button>
    </div>
  </div>
</div>